import Vue from 'vue';
import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { StatService } from '@voice/services/StatService';

export const detailed = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc',
      count: 0
    },
    mutations: {
      increase(state, payload) {
        state.count += payload.amount;
      }
    },
    actions: {
      getData: (_, params) => StatService.getDetailed(params).catch(e => Vue.noty.server_error(e)),
      increaseAsync: ({ commit }, payload) => {
        return commit('increase', payload);
      }
    }
  },
  true
);
